export const BACKGROUND_TYPES = ["color", "gradient", "image"];

export const DEFAULT_BACKGROUND_TYPE = "color";
